function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const GridEquipos = ({ filteredData = [], handleGridInput, handleChangeTextbox, errorRef }) => {
  return (
    
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 bg-secundarioMira rounded-sm shadow-sm elementFadeIn overflow-x-scroll xl:overflow-x-hidden">
              <div className="min-w-full divide-y divide-grisMira /p-5  shadow-sm shadow-grisMira | table-auto xl:table-none sm:overflow-x-scroll xl:overflow-x-hidden">
                
                <div className="sticky top-0 z-10 bg-secundarioMira fadeIn">
                  <div className="w-full divide-x divide-grisMira md:flex flex-col xl:flex-row hidden">
                    <div
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira py-3.5 pl-4 pr-3 sticky w-1/5 text-center"
                    >
                      Id
                    </div>
                    
                    <div
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira py-3.5 pl-4 pr-3 sticky w-2/5 text-center"
                    >
                      Salón
                    </div>
                    <div
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira py-3.5 pl-4 pr-3 sticky w-2/5 text-center"
                    >Mac address
                    </div>
                  </div>
                </div>
                

                <div className="divide-y divide-grisMira bg-primarioMira w-full">
                  {filteredData?.map((element, index) => (
                        <div
                          key={index}
                          className={"divide-x divide-grisMira even:bg-gray-700 flex flex-col md:flex-row"}
                        >
                          <div className=" whitespace-nowrap p-4 text-sm text-white text-center w-full md:w-1/5">
                              <p className={"m-auto"}>{element.Id}</p>  
                          </div>
                          
                          <div className=" text-black whitespace-nowrap text-sm text-center p-2  w-full md:w-2/5">
                              <p className={"m-auto text-white md:hidden"}>Salón</p>
                              <input
                                type="text"
                                name={"Salon"}
                                className={" w-full md:w-[50%] |mx-auto rounded-md bg-gray-100 text-center focus:border-secundario focus:ring-1 focus:ring-secundario transition duration-150 ease-out hover:ease-in"}
                                onBlur={(e) => handleGridInput(e, index)} // evento on change poner la suma para no equivocar los indices o guardar el indice editado para nno equivocarlo handleGridInput = (e, Idx) 
                                onChange={(e) =>{ 
                                  handleChangeTextbox(e, index);
                                }}
                                value={element.Salon}
                              ></input>
                          </div>
                          <div className="text-black whitespace-nowrap text-sm text-center p-2  w-full md:w-2/5">
                              <p className={"m-auto text-white md:hidden"}>Mac Address</p>
                              <input
                                type="text"
                                name={"MacAddress"}
                                className={classNames(element.Incorrecto ? "bg-secundario":"bg-gray-100","w-full md:w-[50%] |mx-auto rounded-md  text-center focus:border-secundario focus:ring-1 focus:ring-secundario transition duration-150 ease-out hover:ease-in")}
                                value={filteredData[index].MacAddress}
                                onBlur={(e) => handleGridInput(e, index)} // evento on change poner la suma para no equivocar los indices o guardar el indice editado para nno equivocarlo handleGridInput = (e, Idx) 
                                onChange={(e) =>{ 
                                  handleChangeTextbox(e, index);
                                  element.Incorrecto = false
                                }}
                              ></input>
                              {element.Incorrecto && <p
                              ref={errorRef}
                              className={"text-secundario"}>MAC Address Incorrecto</p>}
                          </div>
                        </div>
                  ))}
                </div>
              </div>
            </div>
        
  );
};

export default GridEquipos;